import {Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from '../../idex.service';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../shared/toast/toast';
import { UploadCertificateComponent } from 'app/account/upload-certificate/upload-certificate.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmDeleteComponent } from 'app/account/confirm-delete/confirm-delete.component';
import {Path} from '../../shared/path';
import { ChangeCompanyLogoComponent } from '../change-company-logo/change-company-logo.component';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { OrgCertificate } from './org-certificate.model';

declare let $: any;

@Component({
   selector: 'app-company',
   templateUrl: './company-profile.component.html',
   styleUrls: ['./company-profile.component.css']
})
export class CompanyProfileComponent implements AfterViewInit {

   certs: OrgCertificate[] = [];
   saveText: any;

   public companyName: string;
   phonenumber = '';
   domain = '';
   btn_cancel: any;
   public data: any = {
      'name': '',
      'tin' : ''
   };

   defaultValue = 'Ginkgo';

   isExpanded1 = true;
   isExpanded2 = true;
   isEnable = false;

   certIssuer: string;
   certSubject: string;
   certCreationDate: string;
   certExpireDate: string;

   numOfSite: number = 0;
   numOfMember: number = 0;
   siteQuota: number = 0;
   unit: string = 'GB';

   role: string;
   logoLoaded = false;
   logoImg = 'assets/images/photo_gray.png';
   imgWidth = '45px';
   imgHeight = '45px;';
   alignment: string = 'V';
   tin: string;
   id: string;

   constructor(private router: Router,private route: ActivatedRoute, public service: IdexService, private dialog: MatDialog, private toast: Toast,
      private translate: TranslateService) {
         this.translate.get('save').subscribe(s => {
            this.saveText = s;
         });
         if (localStorage.getItem('idex-user')) {
            const user = JSON.parse(localStorage.getItem('idex-user'));
            this.role = user.role;
         }
   }
   ngAfterViewInit(): void {
      this.route.params.subscribe(param => {
         if (param['name']) {
            this.companyName = param['name'];
         }
      });
      setTimeout(() => {
         window.localStorage.setItem('data_company', this.companyName);
         window.localStorage.setItem('path_company', Path.combine('/admin-tool/company-profile', encodeURIComponent(this.companyName)));
         let siteCode = null;
         if(sessionStorage.getItem('siteCode')) {
            siteCode = sessionStorage.getItem('siteCode');
         }
         this.service.getCompanyInfo(encodeURIComponent(this.companyName), siteCode)
            .subscribe(
               data => {
                  this.data = data;
                  this.id = data.id;
                  this.phonenumber = data.cellphone;
                  this.domain = data.domain;
                  window.localStorage.setItem('status', this.data.status);
                  window.localStorage.setItem('tin', this.data.tin);
                  this.service.siteChange.next(this.data.tin);
                  this.tin = this.data.tin;
                  this.loadCerts();
                  this.loadSummaryService();
                  this.service.getLogo(this.id,this.tin).subscribe(rs => {
                     if (rs) {
                        this.logoImg = 'data:' + rs.mimeType + ';base64,' + rs.data;
                        this.changeSize(rs.alignment);
                        this.logoLoaded = true;
                     }
                  });
               });
      }, 0);
   }

   get hasHsmCert(): boolean {
      return this.certs.length > 0 && this.certs[0].certChannel === 'HSM';
   }

   loadCerts(): void {
      this.service.get(`cert/list/ORG?tin=${this.data.tin}`)
         .subscribe(data => {
            if (data) {
               this.certs = data;
               if (!this.hasHsmCert) {
                  this.loadCertInfo();
               }
            }
         });
   }

   loadCertInfo(): void {
      this.service.get(`cert/info/${this.data.tin}`)
         .subscribe(data => {
            if (data) {
               this.certIssuer = data.issuer;
               this.certSubject = data.subject;
               this.certCreationDate = data.creationDate;
               this.certExpireDate  = data.expireDate;
            }
         });
   }

   getExpireDays(expiry: number): number {
      if (!expiry) {
         return 9999;
      }

      const end = new Date(expiry).getTime();
      if (isNaN(end)) {
         return 9999;
      }

      const now = Date.now();

      return Math.floor(
         (end - now) / (1000 * 60 * 60 * 24)
      );
   }

   getExpireBadgeClass(expiry: number): string {
      const days = this.getExpireDays(expiry);
      if (days < 0) {
         return 'expire-expired';
      }
      if (days <= 10) {
         return 'expire-red';
      }
      if (days <= 30) {
         return 'expire-yellow';
      }
      return 'expire-green';
   }

   getExpireBadgeText(expiry: number): string {
      const days = this.getExpireDays(expiry);
      if (days < 0) {
         return this.translate.instant('company.expired-ago', { value: this.getElapsedText(expiry) });
      }
      if (days === 0) {
         return this.translate.instant('company.expire-in-time', { value: this.getRemainingTimeText(expiry) });
      }
      if (days === 1) {
         return this.translate.instant('company.expire-in-a-day');
      }
      return this.translate.instant('company.expire-in-days', { value: days });
   }

   private getElapsedText(expiry: number): string {
      const end = new Date(expiry).getTime();
      const now = Date.now();
      const totalSeconds = Math.floor((now - end) / 1000);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (days === 1) {
         return this.translate.instant('company.elapsed-a-day');
      }
      if (days > 0) {
         return `${days} ${this.unitText('day', days)}`;
      }
      if (hours > 0) {
         return `${hours} ${this.unitText('hour', hours)} ${minutes} ${this.unitText('minute', minutes)} ${seconds} ${this.unitText('second', seconds)}`;
      }
      if (minutes > 0) {
         return `${minutes} ${this.unitText('minute', minutes)} ${seconds} ${this.unitText('second', seconds)}`;
      }
      return `${seconds} ${this.unitText('second', seconds)}`;
   }

   private getRemainingTimeText(expiry: number): string {
      const end = new Date(expiry).getTime();
      const now = Date.now();
      const totalSeconds = Math.max(0, Math.floor((end - now) / 1000));

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (hours > 0) {
         return `${hours} ${this.unitText('hour', hours)} ${minutes} ${this.unitText('minute', minutes)} ${seconds} ${this.unitText('second', seconds)}`;
      }
      if (minutes > 0) {
         return `${minutes} ${this.unitText('minute', minutes)} ${seconds} ${this.unitText('second', seconds)}`;
      }
      return `${seconds} ${this.unitText('second', seconds)}`;
   }

   private unitText(unit: string, count: number): string {
      return this.translate.instant(`company.unit-${unit}${count === 1 ? '' : 's'}`);
   }

   loadSummaryService(): void {
      this.loadNumofSite();
      this.loadNumOfMember();
   }

   loadNumofSite(): void {
      this.service.get(`site/count?tin=${this.data.tin}`)
      .subscribe(data => {
         if (data) {
            this.numOfSite = data;
         }
      });
   }

   loadNumOfMember(): void {
      this.service.get(`work/${this.data.tin}/company/team/count`)
      .subscribe(data => {
         if (data) {
            this.numOfMember = data.numOfMember;
            if(data.quota < 1000){
               this.siteQuota = data.quota;
               this.unit = 'GB';
            } else {
               this.siteQuota = data.quota/1000;
               this.unit = 'TB';
            }
         }
      });
   }

   setExpand1(isExpand: boolean): void {
      this.isExpanded1 = isExpand;
   }

   setExpand2(isExpand: boolean): void {
      this.isExpanded2 = isExpand;
   }

   openUploadCert(): void {
      const dialogRef = this.dialog.open(UploadCertificateComponent, {
         disableClose: true,
         data: {
            'type': 'ORG',
            'tin': this.data.tin,
            'id' : ''
         }
      });

      dialogRef.afterClosed().subscribe(result => {
         this.loadCerts();
      });
   }

   openUpdateCert(data: any): void {
      const dialogRef = this.dialog.open(UploadCertificateComponent, {
         disableClose: true,
         data: {
            'type': 'ORG',
            'tin': this.data.tin,
            'id': data.id
         }
      });

      dialogRef.afterClosed().subscribe(result => {
         this.loadCerts();
      });
   }

   keyPress($event: any) {
      const pattern = /[0-9\ ]/;
      const inputChar = String.fromCharCode($event.charCode);
      if ($event.keyCode !== 8 && !pattern.test(inputChar)) {
         $event.preventDefault();
      }
   }

   onPaste(event: ClipboardEvent) {
      const clipboardData = event.clipboardData || (<any>window).clipboardData;
      const pastedText = clipboardData.getData('text');
      const pattern = /^[0-9]*$/;
      if (!pattern.test(pastedText)) {
         event.preventDefault();
         this.translate.get('company.not-match')
            .subscribe(s => this.toast.error(s.toString()));
      }
   }

   onEdit() {
      this.isEnable = true;
   }

   onCancel() {
      this.phonenumber = this.data.cellphone;
      this.domain = this.data.domain;
      this.isEnable = false;
   }

   saveCompany(companyName: any, cellphone: any, tin: any,domain: string) {
      const pattern = /[0]{1}[1-9]{1}[0-9]{7,8}/;
      if (cellphone.trim() === '' || pattern.test(cellphone)) {
         this.service.updateCompany(companyName, cellphone, tin, domain)
            .subscribe((response) => {
                  this.data.phonenumber = cellphone;
                  this.data.domain = domain;
                  this.translate.get('saving').subscribe(s => {
                     this.saveText = s;
                     setTimeout(() => {
                        this.translate.get('save').subscribe(save => {
                           this.isEnable = false;
                           this.saveText = save;
                           this.toast.success(response);
                        });
                     }, 5000);
                  });
               }, (error) => {
                  this.toast.error(error.message);
                  this.translate.get('save').subscribe(s => {
                     this.saveText = s;
                  });
               }
            );
      } else {
         this.translate.get('alert.invalid_phone').subscribe(s => {
            this.toast.error(s);
         });
      }
   }

   delete(data: any): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {
            item: {
               'id': data.id,
            },
            'service': this.service,
            'name': data.certName
         }
      });

      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.service.delete(`cert/${data.id}`).subscribe(obj => {
               this.onAlert('alert.confirm_delete');
               this.loadCerts();
            });
         }
      });
   }

   onAlert(text: string) {
      this.translate.get(text).subscribe(s => {
         this.toast.success(s);
      });
   }

   gotoSetting() {
      this.router.navigate(['/company-list']);
   }

   openChangeLogo(e: Event) {
      e.stopPropagation();
      const dialogRef = this.dialog.open(ChangeCompanyLogoComponent, {
         disableClose: true,
         data: this
      });
      dialogRef.afterClosed().subscribe(result => {
         this.service.getLogo(this.id,this.tin).subscribe(rs => {
            this.logoImg = 'data:' + rs.mimeType + ';base64,' + rs.data;
            this.changeSize(rs.alignment);
            this.logoLoaded = true;
         });
       });
   }

   radioChange(e: MatRadioChange): void {
      const value = e.value;
      this.changeSize(value);
      if (this.logoLoaded) {
         const data = {
            id: this.id,
            logoAlignment: value
         }
         this.service.updateLogoAlignment(data).subscribe(rs => {
            if (rs){
               this.logoLoaded = true;
            }
         });
      }
   }

   changeSize(value: string): void {
      if (value === 'H') {
         this.imgWidth = '60px';
         this.imgHeight = '18px';
      } else if (value === 'V') {
         this.imgWidth = '45px';
         this.imgHeight = '45px';
      }
      this.alignment = value;
   }
}
